module.exports = __webpack_public_path__ + "img/24.6842a494.png";